<template>
  <div class="preview_xy">
    <div :style="{height:pageSize.height + 'px',width:pageSize.width + 'px'}" class="screen_page_chart" v-if="show">
      <backChart :back="allData.back"></backChart>
      <VueDragResize v-for="(item,index) in vuex.chartList" class="FCharsDrog" :key="index" :preventActiveBehavior="true" :z="item.trans.z" :w="parseFloat(item.trans.width)" :h="parseFloat(item.trans.height)" :x="parseFloat(item.trans.x)" :y="parseFloat(item.trans.y)" :parentLimitation="true">

        <charts :option="item" :index="index" @handleClickData2="getOptionId"></charts>
      </VueDragResize>
      <img src="">
    </div>
  </div>
</template>

<script>
/**
 @author xiaoye
 @date 2020/5/17 7:56 下午
 */
import backChart from '../../charts/backChart'
import VueDragResize from 'vue-drag-resize';
import charts from '../../charts/charts'
import {
  GetScreenPageIndexByID,
  GetScreenByGroupID
} from '@/assets/axios/createScreen/configScreen'
import modules from '../../../charts/script/modules'

export default {
  name: 'preview',
  components: {
    VueDragResize,
    charts,
    backChart,
  },
  props: {
    toChartData: {
      //对象形式接收  =>推荐使用此方式，直接可以通过this.toChildVal取值
      type: Object, //设置数据类型
      default: {}, //数据默认值
    },
  },

  data() {
    return {
      childList: [],
      optionId: "",
      show: false,
      //id
      viewScree: {
        //模版id
        modeId: '',
        //大屏id
        viewDPId: ''
      },
      chartList: [],
      pageSize: {
        width: 0,
        height: 0
      },
    }
  },
  methods: {
    getOptionId(optionId) {
      this.optionId = optionId
      this.$emit("handleClickData3", this.optionId)
    },
    async init() {
      //获取模版ID
      let modeId = await this.getSession('screen_module_xy');
      //获取图表ID
      let viewDPId = await this.getSession('screen_viewDp_xy');
      if (modeId) {
        this.viewScree.modeId = modeId;
      }
      if (viewDPId) {
        this.viewScree.viewDPId = viewDPId;
      } else {
        this.getMsg('请求失败 请重新尝试');
      }
      await this.getChart();
    },
    //查询当前页面的子图表
    async getChart() {
      this.show = false;
      await GetScreenPageIndexByID({
        screenID: this.viewScree.viewDPId
      }).then(async res => {
        if (res.code === 200) {
          let node = res.data;
          this.pageSize.width = node.sizeX || 0;
          this.pageSize.height = node.sizeY || 0;
          this.show = true;
          var childList = []
          var viewIdList = []
          var webIdList = []

          for (var i = 0; i < res.data.child.length; i++) {
            var viewId = JSON.parse(res.data.child[i].requestJson).viewDP.viewId
            viewIdList.push(viewId)
            var webId = res.data.child[i].webID
            webIdList.push(webId)
            childList.push({
              viewId: viewIdList[i],
              webId: webIdList[i]
            })
          }
          this.childList = childList;
          this.$emit("handleClickData", this.childList)


          try {
            this.$nextTick(async () => {
              this.show = true;
              let pageParam = JSON.parse(node.screenJson);
              let defaultVal = this.$store.state.designer.defaultVal;
              this.allData = JSON.parse(JSON.stringify(await this.getDGCopy(defaultVal.pageParam, pageParam)));
              let modu = modules;
              await this.$store.dispatch('screenAllRender', { modu, node });
            })
          } catch (e) {
            this.show = false;
          }
        }
      });
    },
  },
   watch: {
toChartData(){
  // this.getChart()
}
  },
  computed: {
    //公共的参数
    nowChart() {
      return this.$store.state.designer.nowChart;
    },
    vuex() {
      return this.$store.state.designer;
    },
    allData: {
      get() {
        return JSON.parse(JSON.stringify(this.vuex.defaultVal.pageParam));
      },
      set(data) {
        return data
      }
    }
  },
  mounted() {
    this.init();
  },
  async beforeDestroy() {
    await this.$store.dispatch('clearDesigner');
  }
}
</script>

<style lang="less">
.preview_xy {
  width: 100%;
  height: 100%;

  > div {
    position: relative;
  }
}
</style>
